import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaInfoCircle } from "react-icons/fa";
import { verifyThunk } from "../../Redux/thunks/verifyThunks";

import {
    setUIN,
    RESET_ALL_STATES,
    setVerified,
    setLogin,
} from "../../Redux/actions/actions";
import { Tooltip } from "antd";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { persistor } from "../../Redux/store";
import DOMPurify from "dompurify";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import validateFIN_FCN from "./validateFIN_FCN";
import Footer from "../../Components/Footer/footer";
import NavBar from "../../Components/Nav/newNavBar";
import i18next from "i18next";
import { Loader } from "lucide-react";
import { Trans } from 'react-i18next';
import esignetClient from './../../auth/esignet';
import { use } from "react";
import {useLocation } from "react-router-dom";
import { VALIDATE_OTP_SUCCESS } from "../../Redux/actions/actionTypes";
import { esignetThunk } from "../../Redux/thunks/esignetThunk";
import otpReducer from "../../Redux/reducers/otpReducer";


const FinVerification = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const isLoading = useSelector((state) => state.verify.isLoading);

    const error = useSelector((state) => state.verify.error);
    const data = useSelector((state) => state.verify.data);
    const faceAuthData = useSelector((state) => state.faceAuth.data);
    const { t } = useTranslation();
    const token = data?.token;
    const isAuthenticated = useSelector(
        (state) => state.session.isAuthenticated
    );
    const isVerified = useSelector((state) => state.session.isVerified);

    const [sanitizedIdNumber, setSanitizedIdNumber] = useState("");
    const [idNumber, setIdNumber] = useState("");
    const [verificationMethod, setVerificationMethod] = useState("FCN");
    const [showPassword, setShowPassword] = useState(false);
    const [showError, setShowError] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [captchaValue, setCaptchaValue] = useState(null);

    const executeReCAPTCHA = () => {
        return new Promise((resolve, reject) => {
            if (window.grecaptcha && window.grecaptcha.ready) {
                window.grecaptcha.ready(() => {
                    window.grecaptcha
                        .execute(process.env.REACT_APP_CAPTCHA_KEY, {
                            action: "submit",
                        })
                        .then((token) => {
                            if (token) {
                                resolve(token);
                            } else {
                                reject(
                                    new Error(
                                        "Failed to retrieve reCAPTCHA token."
                                    )
                                );
                            }
                        });
                });
            } else {
                reject(new Error("reCAPTCHA not ready"));
            }
        });
    };

    useEffect(() => {
        const processCallback = async () => {
            const params = new URLSearchParams(location.search);
            const code = params.get("code");
            const state = params.get("state");
            const path = location.pathname;

            if (path === "/callback" && code && state) {
                try {
                    dispatch(esignetThunk(code));
                    localStorage.setItem("xcode", code);
                    localStorage.setItem("xstate", state);
                } catch (error) {
                    console.error("Error processing callback:", error);
                }
            }
        };

        if(isAuthenticated) {
            navigate("/dashboard");
        } else {
            processCallback();
        }
       
    }, [isAuthenticated]);

    useEffect(() => {
        setShowError("");
        if (isAuthenticated) {
            navigate("/dashboard");
        } else if (isVerified) {
            dispatch({ type: RESET_ALL_STATES });
            persistor.purge();
            // dispatch({ type: "LOGOUT" });
        } else if (token) {
            dispatch(setUIN(sanitizedIdNumber, verificationMethod));
            dispatch(setVerified());
            navigate("/otp");
        } else if (data?.errors) {
            setShowError(data?.errors);
        } else if (error) {
            setShowError(error?.message);
        }
    }, [data, error, navigate, dispatch]);

    const handleToggle = (method) => {
        setVerificationMethod(method);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        await esignetClient.login() 
    };

    const inputRef = useRef(null);

    const handleIdNumberChange = (event) => {
        const value = event.target.value.replace(/\D/g, "");
        if (value.length <= 16) {
            setIdNumber(value);
            setVerificationMethod(value.length <= 12 ? "FIN" : "FCN");
        }

        if (inputRef.current) {
            inputRef.current.value = value;
        }
    };

    const getMaxLength = () => {
        return 16;
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const randomName = Math.random().toString(36).substring(7);

    return (
        <div className='relative md:min-h-[100dvh] overflow-hidden bg-cover bg-fin-verification'>
            <NavBar />

            <div className='relative flex flex-col overflow-y-scroll scrollbar-hide py-32 md:min-h-screen md:pb-[6%] items-center justify-center bg-cover bg-opacity-6 font-barlow px-5'>
                <form
                    onSubmit={handleSubmit}
                    autoComplete='off'
                    className='max-w-[560px] text-center shadow-lg rounded-2xl overflow-hidden'
                >
                    <div className='bg-[#184C61] p-8 text-white flex flex-col'>
                        <p className='text-4xl font-thin'>{t("home-title1")}</p>
                        <div className='flex flex-wrap justify-center'>
                            <p className='text-3xl font-bold'>
                                {t("home-title2")}
                            </p>
                            {i18next.language === "amh" ? (
                                <>
                                    <p className='text-3xl font-bold'>
                                        {t("home-title3")}
                                    </p>
                                    <p className='text-3xl font-bold'>
                                        {t("home-title4")}
                                    </p>
                                </>
                            ) : null}
                        </div>
                        <p 
                        className="text-lg mt-2 leading-6 text-justify mx-auto max-w-prose"
                        style={{ textAlignLast: 'center' }}
                        >
                        <Trans
                            i18nKey="home-description"
                            components={{
                            // eslint-disable-next-line jsx-a11y/anchor-has-content
                            1: <a
                                href="https://id.et/updatecenters"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-realnidgreen hover:underline"
                                />
                            }}
                        />
                        </p>
                    </div>
                    <div className='bg-white'>
                        <div className='p-8 flex flex-col gap-2 text-MetallicBlue max-w-[400px] mx-auto'>
                            <p className='text-2xl font-semibold'>
                                {t("login")}
                            </p>
                          
                            <button
                                type='submit'
                                disabled={isClicked || isLoading}
                                className={`${
                                    isClicked || isLoading
                                        ? "disabled hover:bg-gray-300 hover:text-gray-500 hover:cursor-not-allowed"
                                        : ""
                                } px-10 py-2 rounded-lg bg-[#FFB400] border border-MetallicBlue`}
                            >
                                {isLoading ? (
                                    <div className='flex items-center gap-2 justify-center'>
                                        <Loader className='animate-spin' />
                                        {t("home-button-verifying")}
                                    </div>
                                ) : (
                                    t("home-button-proceed")
                                )}
                            </button>
                            <div className='underline text-sm flex gap-10 justify-center'>
                                <Link to='/resend'>
                                    {t("home-button-resend")}
                                </Link>
                                <Link to='/status'>
                                    {t("home-button-status")}
                                </Link>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <Footer />
        </div>
    );
};

export default FinVerification;
